import { type FC, type SVGProps, useEffect, useState } from 'react';

import { useMyWatches } from '@/hooks/useMyWatches';

import * as S from './DownloadableCert.styles';
interface DownloadableCertProps {
  Svg: FC<SVGProps<SVGSVGElement>>;
  channel: string;
  fileName: string;
  sn: string;
  text: string;
}
export const DownloadableCert = ({
  Svg,
  channel,
  fileName,
  sn,
  text,
}: DownloadableCertProps) => {
  const { getCertificates } = useMyWatches();
  const [downLoadUrl, setDownLoadUrl] = useState('');
  useEffect(() => {
    (async () => {
      if (sn && channel) {
        const obj = await getCertificates(sn, fileName, channel);
        const url = window.URL.createObjectURL(obj as Blob);
        setDownLoadUrl(url);
      }
    })();
  }, [sn, channel]);
  return (
    <S.CertWrapper
      data-test-id='DownloadableCertCertWrapper'
      download={`${fileName}.pdf`}
      href={downLoadUrl}
      isDisabled={!downLoadUrl}
    >
      <Svg data-test-id='DownloadableCertSvg' height={64} width={64} />
      <S.Text data-test-id='DownloadableCertText'>{text}</S.Text>
    </S.CertWrapper>
  );
};

DownloadableCert.displayName = 'DownloadableCert';
